// DS: IL5
// from GDrive
import React from 'react';
export class TrashCan extends React.PureComponent {
    render() {
        return /*#__PURE__*/ React.createElement("svg", {
            width: "88",
            height: "88",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ React.createElement("g", {
            fill: "currentColor"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M44 66c.55 0 1-.45 1-1V32c0-.55-.45-1-1-1s-1 .45-1 1v33c0 .55.45 1 1 1zM34 66c.55 0 1-.45 1-1V32c0-.55-.45-1-1-1s-1 .45-1 1v33c0 .55.45 1 1 1zM54 66c.55 0 1-.45 1-1V32c0-.55-.45-1-1-1s-1 .45-1 1v33c0 .55.45 1 1 1z"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M67 21H52.96c-.11-1.25-.49-3.36-1.81-4.71-.84-.86-1.9-1.29-3.15-1.29H38c-1.25 0-2.31.43-3.14 1.29-1.32 1.35-1.7 3.46-1.81 4.71H21c-.55 0-1 .45-1 1s.45 1 1 1h2.04l1.92 46.02c.03 1.72 1.1 4.98 4.9 4.98h28.27c3.8 0 4.87-3.26 4.91-4.96L64.96 23H67c.55 0 1-.45 1-1s-.45-1-1-1zm-30.71-3.32c.45-.46 1.01-.68 1.71-.68h10c.7 0 1.26.22 1.71.68.8.82 1.13 2.27 1.24 3.32h-15.9c.11-1.05.44-2.5 1.24-3.32zm24.75 51.3c0 .31-.14 3.02-2.9 3.02H29.86c-2.73 0-2.9-2.72-2.91-3.04L25.04 23h37.92l-1.92 45.98z"
        })));
    }
}

//# sourceMappingURL=TrashCan.js.map